/**
 * @generated SignedSource<<69e80f4bcac43ec44c8768626d38c0db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeSelect_data$data = {
  readonly allWhatToSees: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "WhatToSeeSelect_data";
};
export type WhatToSeeSelect_data$key = {
  readonly " $data"?: WhatToSeeSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeSelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeSelect_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WhatToSee",
      "kind": "LinkedField",
      "name": "allWhatToSees",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6ff3b783a0ffff3121c59e6758de85c4";

export default node;
